import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type ChatIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const ChatIllustration = ({ ...props }: ChatIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" fill="none">
      <path d="M57,6H7a5,5,0,0,0-5,5V41a5,5,0,0,0,5,5H22L32,58,42,46H57a5,5,0,0,0,5-5V11A5,5,0,0,0,57,6Z" />
      <line x1="16" x2="48" y1="20" y2="20" />
      <line x1="16" x2="34" y1="32" y2="32" />
    </g>{' '}
  </BaseIllustration>
);

ChatIllustration.displayName = 'ChatIllustration';
